document.addEventListener('DOMContentLoaded', function() {

    document.querySelectorAll('.add-to-cart-listing-btn').forEach(function(btn) {
        const productId = btn.getAttribute('data-product-id');
        const ajaxUrl = btn.getAttribute('data-ajax-url');
        const icon = btn.querySelector('i');
        
        if (!productId || !ajaxUrl || !icon) return;

        fetch(ajaxUrl + '?action=check_product_in_cart&product_id=' + productId)
            .then(response => response.json())
            .then(data => {
                if (data && data.in_cart) {
                    icon.className = 'bi bi-check-circle-fill';
                }

                console.log('SONUÇ:', data)
            })
            .catch(err => console.error('Sepet kontrol hatası:', err));
    });
    
    // Global tıklama dinleyicisi (Event Delegation)
    document.addEventListener('click', function(e) {
        // Tıklanan elemanın kendisi veya ebeveynlerinde sepet butonu sınıfı var mı kontrol et
        const btn = e.target.closest('.add-to-cart-listing-btn');
        if (!btn) return;

        const productId = btn.getAttribute('data-product-id');
        const productQuantity = btn.getAttribute('data-quantity') || '1';
        const ajaxUrl = btn.getAttribute('data-ajax-url');
        const icon = btn.querySelector('i');

        // Gerekli veriler yoksa veya halihazırda sepete eklenmişse/stokta yoksa işlemi durdur
        if (!productId || !ajaxUrl || !icon) return;
        if (icon.classList.contains('bi-check-circle-fill') || icon.classList.contains('bi-x-circle')) return;

        // İstek gönderilirken ikonu geçici olarak yükleniyor yapalım (Kullanıcı deneyimi için harika olur)
        icon.className = 'bi bi-arrow-repeat animate-spin';

        // AJAX isteği
        fetch(ajaxUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
                action: 'woocommerce_add_to_cart',
                product_id: productId,
                quantity: productQuantity
            })
        })
        .then(response => response.json())
        .then(data => {
            icon.className = 'bi bi-check-circle-fill';

            if (data && data.fragments && data.fragments['#update-cart']) {
                const temp = document.createElement('div');
                temp.innerHTML = data.fragments['#update-cart'];
                const newEl = temp.firstElementChild;
                const oldEl = document.getElementById('update-cart');
                if (oldEl && newEl) oldEl.replaceWith(newEl);
            }

            if (typeof jQuery !== 'undefined') {
                jQuery(document.body).trigger('wc_fragment_refresh');
            }
        })
        .catch(err => {
            icon.className = 'bi bi-cart';
            console.error('Sepete ekleme hatası:', err);
        });
    });

});